import { UnorderedListOutlined } from "@ant-design/icons"
import { Col, Divider, Row, Tabs, Typography } from "antd"
import { useState } from "react"
import PrePayment from "../Manager/Orders/PrePayment"
import AllOrdersTable from "../Manager/Orders/AllOrdersTable"
import TapeOrders from "../Manager/Orders/TapeOrders"
import ArsomaTable from "../Manager/Orders/ArsomaTable"
import VivaTable from "../Manager/Orders/VivaTable"
import WinderTable from "../Manager/Orders/WinderTable"
import WarehouseOrders from "../Warehouse/Orders/WarehouseOrders"
import CompletedOrders from "../Manager/Orders/CompletedOrders"
import WarehouseAwaitingDocument from "../Manager/Orders/WarehouseAwaitingDocument"
import { useCollection } from "../../hooks/useCollection"
import { useAuthContext } from "../../hooks/useAuthContext"

const { Title, Paragraph } = Typography

export default function DevSpecOrders() {
  const { user } = useAuthContext()

  const { data: prePOrders, loading: prePLoading } = useCollection("orders", [
    "orderStatus",
    "==",
    0.5,
  ])

  const { data: awaitingWOrders, loading: awaitingWOrdersLoading } = useCollection(
    "orders",
    ["orderStatus", "==", 6],
    ["hasInvoice", "==", false]
  )
  const { loading, data } = useCollection("orders", ["orderStatus", "<=", 6])

  const { data: doneOrders, loading: doneOrdersLoading } = useCollection(
    "orders",
    ["orderStatus", "==", 6],
    ["hasInvoice", "==", true]
  )

  const [currentKey, setCurrentKey] = useState(1)

  const onChange = (key) => {
    setCurrentKey(key)
    console.log(key)
  }

  const items = [
    {
      key: 0,
      label: "Pre Payment",
      children: <PrePayment data={prePOrders} loading={prePLoading} />,
    },
    {
      key: "1",
      label: `Active Orders (mine)`,
      children: <AllOrdersTable loading={loading} data={data} />,
    },
    {
      key: 2,
      label: `Tape (printing)`,
      children: <TapeOrders activeKey={currentKey} user={user} />,
    },
    {
      key: 3,
      label: `Arsoma (printing)`,
      children: <ArsomaTable user={user} currentKey={currentKey} />,
    },
    {
      key: 4,
      label: `Viva (printing)`,
      children: <VivaTable user={user} currentKey={currentKey} />,
    },
    {
      key: 4.5,
      label: `Winder (printing)`,
      children: <WinderTable user={user} currentKey={currentKey} />,
    },
    {
      key: 5,
      label: "Warehouse (awaiting docs)",
      children: (
        <WarehouseAwaitingDocument initialData={awaitingWOrders} loading={awaitingWOrdersLoading} />
      ),
    },
    {
      key: 5.5,
      label: "Warehouse (has doc)",
      children: <WarehouseOrders initialData={doneOrders} loading={doneOrdersLoading} />,
    },

    {
      key: 7,
      label: `Completed`,
      children: <CompletedOrders currentKey={currentKey} />,
    },
  ]

  return (
    <div>
      <Row gutter={[0, 15]}>
        <Col span={24}>
          <div style={{ padding: 15 }}>
            <Title level={3}>
              <UnorderedListOutlined />
              <Divider type="vertical" />
              My Orders
            </Title>
          </div>
        </Col>
        <Col span={24}>
          <Paragraph type="secondary">
            This is a orders section. Here you can view and filter all kinds of orders. Everything
            that is created/edited are being displayed here.
          </Paragraph>
        </Col>
      </Row>

      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </div>
  )
}
